module.exports = __webpack_public_path__ + "img/10-m.1d65931d.jpg";